import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, DatePicker, Space, Select } from 'antd';
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import { Btns, FormContainer } from "./styled";
import dayjs from 'dayjs';


export function ModalTratamento({ isOpen, onClose, id, fetchPendentesData, fetchEmitidasData }) {

    
    const dateFormat = 'YYYY-MM-DD';
    const [atualDate, setAtualDate] = useState(dayjs().format(dateFormat));
    const [tipoList, setTipoList] = useState([]);
    const [situacaoList, setSituacaoList] = useState([]);
    const [categoriaList, setCategoriaList] = useState([]);
    const [motivoList, setMotivoList] = useState([]);
    const [isMotivo, setIsMotivo] = useState(false);
    const [isFechamento, setIsFechamento] = useState(false);

    const [newData, setNewData] = useState({
        id: "",
        cliente: "",
        categoriaId: "",
        categoriaNome: "",
        tipoId: "",
        tipoNome: "",
        situacaoId: "",
        situacaoNome: "",
        motivoId: "",
        motivoNome: "",
        titulo: "",
        descricao: "",
        usuarioSit: "",
        usuarioAbertura: "",
        dataSit: "",
        dataAbertura: "",
        fechamento: ""
    })

    useEffect(() => {
        setAtualDate(dayjs().format(dateFormat));
        consultarData(id);
        // setIsItCliente(id);


    }, []);

    const consultarData = async (id) => {
        const url = "/portal/rest/contador/atendimento/consultar";
        const param = {
            id: id
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            const data = response.data;

            setNewData(prevState => ({
                ...prevState,
                id: data.id,
                cliente: data.cliente.id,
                categoriaNome: data.categoria.nome,
                categoriaId: data.categoria.id,
                tipoId: data.tipo.id,
                tipoNome: data.tipo.nome,
                situacaoId: data.situacao.id,
                situacaoNome: data.situacao.nome,
                titulo: data.titulo,
                descricao: data.memo,
                usuarioSit: data.usuarioSituacao.id,
                usuarioAbertura: data.usuarioCadastro.id,
                dataSit: convertTimestampToDate(data.dataSituacao),
                dataAbertura: convertTimestampToDate(data.dataCadastro)
            }));

            getListCategoria();
            getListTipo();
            getListMotivo();
            getListSituacao();

        } catch {
            toast.error("Erro ao buscar os dados.");
        }
    }

    const getListCategoria = async () => {
        const url = "/portal/rest/contador/atendimento/categoria/listar"
        const param = {}

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setCategoriaList(response.data);
        } catch {

        }
    }

    const getListTipo = async (value) => {
        const url = "/portal/rest/contador/atendimento/tipo/listar"
        const param = {
            categoria: {
                id: value
            }
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setTipoList(response.data);
        } catch {

        }
    }

    const getListMotivo = async (value) => {

        const url = "/portal/rest/contador/atendimento/motivo/listar"
        const param = {
            tipo: {
                id: value
            }
        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setMotivoList(response.data);
        } catch {

        }
    }

    const getListSituacao = async () => {
        const url = "/portal/rest/contador/atendimento/situacao/listar"
        const param = {}

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            setSituacaoList(response.data);
        } catch {

        }
    }

    const postData = async () => {
        const url = "/portal/rest/contador/atendimento/atualizar";
        const param = {
            categoria: {
                id: newData.categoriaId
            },
            cliente: {
                id: newData.cliente
            },
            id: newData.id,
            memo: newData.descricao,
            memoFechamento: newData.fechamento,
            situacao: {
                id: newData.situacaoId
            },
            tipo: {
                id: newData.tipoId
            },
            motivo: {
                id: newData.motivoId
            },
            titulo: newData.titulo


        }

        try {
            const response = await axios.post(url, param, { withCredentials: true });
            onClose();
            fetchPendentesData();
            fetchEmitidasData();
            toast.success("Atendimento tratado com sucesso!")
        } catch {
            toast.error("não foi possível salvar os dados.");
        }
    }

    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp, 10));
    };

    const handleCancel = () => {
        onClose();
    };

    const clearForm = () => {
        setNewData({
            codigo: "",
            id: "",
            senha: "",
            site: "",
            tipo: ""
        });
    };

    const changeId = (e) => {
        setNewData({
            ...newData,
            id: e.target.value
        })
    }

    const changeCliente = (e) => {
        setNewData({
            ...newData,
            cliente: e.target.value
        })
    }

    const onChangeCategoria = (value, nome) => {
        setNewData({
            ...newData,
            categoriaId: value,
            categoriaNome: nome.label
        })
        getListTipo(value);

    };

    const onChangeTipo = (value, nome) => {
        setNewData({
            ...newData,
            tipoId: value,
            tipoNome: nome.label
        })

        switch (value) {
            case 603000:
                getListMotivo(value);
                setIsMotivo(true);
                break;
            case 209100:
                getListMotivo(value);
                setIsMotivo(true);
                break;
            case 209000:
                getListMotivo(value);
                setIsMotivo(true);
                break;
            case 209000:
                getListMotivo(value);
                setIsMotivo(true);
                break;
            case 2093000:
                getListMotivo(value);
                setIsMotivo(true);
                break;
            default:
                setIsMotivo(false);
                break;
        }
    };

    const onChangeMotivo = (value, nome) => {
        setNewData({
            ...newData,
            motivoId: value,
            motivoNome: nome.label
        })
    }

    const changeTitulo = (e) => {
        setNewData({
            ...newData,
            titulo: e.target.value
        })
    }

    const changeDescricao = (e) => {
        setNewData({
            ...newData,
            descricao: e.target.value
        })
    }

    const onChangeSituacao = (value, nome) => {
        setNewData({
            ...newData,
            situacaoId: value,
            situacaoNome: nome
        })

        if (value === "F") {
            setIsFechamento(true);
        } else {
            setIsFechamento(false);
        }
    }

    const changeFechamento = (e) => {
        setNewData({
            ...newData,
            fechamento: e.target.value
        })
    }

    return (

        <>
            <Modal
                title="Tratamento de Atendimento"
                open={isOpen}
                onOk={postData}
                onCancel={handleCancel}
                width={800}
            >
                <FormContainer>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="id"
                        >
                            <label className="label" tmlFor="">Id:</label>
                            <Input disabled placeholder={newData.id || "Id"} onChange={changeId} value={newData.id} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="cliente"
                        >
                            <label className="label" htmlFor="">Cliente:</label>
                            <Input disabled placeholder={newData.cliente || "cliente"} onChange={changeCliente} value={newData.cliente} />
                        </Form.Item>
                    </div>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="categoria"
                            value={newData.categoriaNome}
                            style={{ width: "190px" }}
                        >
                            <label className="label" htmlFor="">Categoria:</label>
                            <Select
                                showSearch
                                placeholder={newData.categoriaNome}

                                onChange={onChangeCategoria}
                                filterOption={(input, option) =>
                                    option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                }
                            >
                                {categoriaList.map(item => (
                                    <Select.Option key={item.id} value={item.id} label={item.nome} >
                                        {item.nome}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="Tipo"
                            value={newData.tipoNome}
                            style={{ width: "190px" }}
                        >
                            <label className="label" htmlFor="">Tipo:</label>
                            <Select
                                showSearch
                                placeholder={newData.tipoNome}

                                onChange={onChangeTipo}
                                filterOption={(input, option) =>
                                    option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                }
                            >
                                {tipoList.map(item => (
                                    <Select.Option key={item.id} value={item.id} label={item.nome} >
                                        {item.nome}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {isMotivo && (
                            <Form.Item
                                className="form-item"
                                name="Motivo"
                                value={newData.motivoNome}
                                style={{ width: "190px" }}
                            >
                                <Select
                                    showSearch
                                    placeholder="Selecione o motivo"
                                    onChange={onChangeMotivo}
                                    filterOption={(input, option) =>
                                        option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                    }
                                >
                                    {motivoList.map(item => (
                                        <Select.Option key={item.id} value={item.id} label={item.nome} >
                                            {item.nome}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </div>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="titulo"
                        >
                            <label className="label" htmlFor="">Título:</label>
                            <Input style={{ width: "500px", display: "flex" }} placeholder={newData.titulo || "titulo"} onChange={changeTitulo} value={newData.titulo} />
                        </Form.Item>
                    </div>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="decricao"

                        >
                            <label className="label" htmlFor="">Descrição:</label>
                            <Input.TextArea style={{ width: "500px", height: "130px", display: "flex" }} onChange={changeDescricao} value={newData.descricao} />
                        </Form.Item>
                    </div>
                    {isFechamento && (
                        <div className="form-content">
                            <Form.Item
                                className="form-item"
                                name="fechamento"
                            >
                                <label className="label" htmlFor="">Fechamento:</label>
                                <Input.TextArea style={{ width: "500px", height: "130px", display: "flex" }} onChange={changeFechamento} value={newData.fechamento} />
                                <p style={{ color: "rgb(255 0 0 / 55%)" }}>(Atenção: o texto informativo de fechamento acima será enviado por email para o cliente)</p>
                            </Form.Item>
                        </div>
                    )}
                    <div className="form-content">
                        <Form.Item
                            className="form-item"
                            name="situação"
                            value={newData.situacaoNome}
                            defaultValue={newData.situacaoNome}
                        >
                            <label className="label" htmlFor="">Situação:</label>
                            <Select
                                showSearch
                                placeholder={newData.situacaoNome}
                                onChange={onChangeSituacao}

                                filterOption={(input, option) =>
                                    option.nome.toLowerCase().indexOf(input.toLowerCase()) > 0
                                }
                            >
                                {situacaoList.map(item => (
                                    <Select.Option key={item.id} value={item.id} label={item.nome}>
                                        {item.nome}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="dataSit"
                        >
                            <label className="label" htmlFor="">Data Situação::</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.dataSit} value={newData.dataSit} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="usuarioSit"
                        >
                            <label className="label" htmlFor="">Usuário situação:</label>
                            <Input disabled placeholder={newData.usuarioSit || "usuarioSit"} value={newData.usuarioSit} />
                        </Form.Item>
                    </div>
                    <div className="form-content">
                        <Form.Item
                            className="form-item"

                            name="dataAbertura"
                        >
                            <label className="label" htmlFor="">Data abertura:</label>
                            <Input style={{ width: "auto" }} disabled placeholder={newData.dataAbertura} value={newData.dataAbertura} />
                        </Form.Item>
                        <Form.Item
                            className="form-item"
                            name="usuarioAbertura"
                        >
                            <label className="label" htmlFor="">Usuário Abertura:</label>
                            <Input disabled placeholder={newData.usuarioAbertura || "usuarioAbertura"} value={newData.cliente} />
                        </Form.Item>
                    </div>
                </FormContainer>
            </Modal>
        </>
    );
};

export default ModalTratamento;